import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy'
})
export class FilterPipe implements PipeTransform {

  public transform(input, term: any, searchkey: string, equals?: boolean) {
    if (term && Array.isArray(input)) {

      if ( typeof term === 'string' ) {
        // String search
        return input.filter((item) => {
          if ( !term || term.trim() === '' ){
            return true;
          }
          let matched = false;
          if ( searchkey ) {
            if ( equals ) {
              return (item[searchkey] === term) ? true : false;
            } else {
              const regExp = new RegExp(term, 'gi');
              matched = matched || regExp.test(item[searchkey]);
              return matched;
            }
          }
          for (const key in item) {
            if (item.hasOwnProperty(key)) {
              if (term) {
                if ( equals ) {
                  matched = (item[key] === term) ? true : false;
                } else {
                  const regExp = new RegExp(term, 'gi');
                  matched = matched || regExp.test(item[key]);
                }
              }
            }
          }
          return matched;
        });

      } else {
        // Multiple keyes search
        const filterKeys = Object.keys(term);
        if (equals) {
          return input.filter(item =>
              filterKeys.reduce((memo, keyName) =>
                  (memo && new RegExp(term[keyName], 'gi').test(item[keyName])) || term[keyName] === '', true));
        } else {
          return input.filter(item => {
            return filterKeys.some((keyName) => {
              return new RegExp(term[keyName], 'gi').test(item[keyName]) || term[keyName] === '';
            });
          });
        }
      }
    } else {
      return input;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/filter.pipe.ts